import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, PhoneIcon, ChevronDownIcon } from 'lucide-react';
export function Navbar({
  onNavigate,
  currentPage,
  onOpenQuote
}: {
  onNavigate: (page: string) => void;
  currentPage: string;
  onOpenQuote?: () => void;
}) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleNav = (page: string) => {
    onNavigate(page);
    setMobileMenuOpen(false);
    setServicesDropdownOpen(false);
  };
  const linkClass = (page?: string) => `font-medium transition-colors cursor-pointer ${page && currentPage === page ? 'text-accent' : 'text-slate-600 hover:text-accent'}`;
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-3' : 'bg-white py-5'}`} data-id="element-206">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-207">
        <div className="flex justify-between items-center" data-id="element-208">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-209">
            <button onClick={() => handleNav('home')} className="block" data-id="element-210">
              <img src="https://cdn.magicpatterns.com/uploads/fRhFPj1omhhVd8L4VTw3h8/ChatGPT_Image_Apr_29,_2026,_09_10_58_PM.png" alt="Ambient Telecom Solutions" className="h-20 w-auto" data-id="element-211" />
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex space-x-8 items-center" data-id="element-212">
            <button onClick={() => handleNav('about')} className={linkClass('about')} data-id="element-213">
              About Us
            </button>
            <button onClick={() => handleNav('domains-hosting')} className={linkClass('domains-hosting')} data-id="element-214">
              Domains & Hosting
            </button>

            {/* Services Dropdown */}
            <div className="relative group" onMouseEnter={() => setServicesDropdownOpen(true)} onMouseLeave={() => setServicesDropdownOpen(false)} data-id="element-215">
              <button className={`flex items-center hover:text-accent font-medium transition-colors py-2 ${['business-internet', 'ethernet-fiber', 'network-security', 'ucaas', 'business-phone', 'video-monitoring', 'access-control', 'ethernet-cabling', 'website-design'].includes(currentPage) ? 'text-accent' : 'text-slate-600'}`} data-id="element-216">
                Services <ChevronDownIcon className="ml-1 w-4 h-4" data-id="element-217" />
              </button>

              {servicesDropdownOpen && <div className="absolute top-full left-0 w-64 bg-white shadow-xl rounded-lg py-2 border border-slate-100 transition-opacity" data-id="element-218">
                  <div className="px-4 py-1.5 text-xs font-bold text-slate-400 uppercase tracking-wider" data-id="element-219">
                    Internet & Phone
                  </div>
                  <button onClick={() => handleNav('business-internet')} className={`block w-full text-left px-4 py-2 text-sm hover:bg-slate-50 hover:text-accent ${currentPage === 'business-internet' ? 'text-accent font-medium bg-slate-50' : 'text-slate-700'}`} data-id="element-220">
                    Business Internet
                  </button>
                  <button onClick={() => handleNav('ucaas')} className={`block w-full text-left px-4 py-2 text-sm hover:bg-slate-50 hover:text-accent ${currentPage === 'ucaas' ? 'text-accent font-medium bg-slate-50' : 'text-slate-700'}`} data-id="element-221">
                    UCaaS Phone Systems
                  </button>
                  <button onClick={() => handleNav('ethernet-fiber')} className={`block w-full text-left px-4 py-2 text-sm hover:bg-slate-50 hover:text-accent ${currentPage === 'ethernet-fiber' ? 'text-accent font-medium bg-slate-50' : 'text-slate-700'}`} data-id="element-222">
                    Ethernet – Fiber
                  </button>
                  <button onClick={() => handleNav('business-phone')} className={`block w-full text-left px-4 py-2 text-sm hover:bg-slate-50 hover:text-accent ${currentPage === 'business-phone' ? 'text-accent font-medium bg-slate-50' : 'text-slate-700'}`} data-id="element-223">
                    Business Phone
                  </button>

                  <div className="border-t border-slate-100 my-1" data-id="element-224"></div>
                  <div className="px-4 py-1.5 text-xs font-bold text-slate-400 uppercase tracking-wider" data-id="element-225">
                    Security
                  </div>
                  <button onClick={() => handleNav('video-monitoring')} className={`block w-full text-left px-4 py-2 text-sm hover:bg-slate-50 hover:text-accent ${currentPage === 'video-monitoring' ? 'text-accent font-medium bg-slate-50' : 'text-slate-700'}`} data-id="element-226">
                    Video & Monitoring
                  </button>
                  <button onClick={() => handleNav('access-control')} className={`block w-full text-left px-4 py-2 text-sm hover:bg-slate-50 hover:text-accent ${currentPage === 'access-control' ? 'text-accent font-medium bg-slate-50' : 'text-slate-700'}`} data-id="element-227">
                    Access Control
                  </button>
                  <button onClick={() => handleNav('network-security')} className={`block w-full text-left px-4 py-2 text-sm hover:bg-slate-50 hover:text-accent ${currentPage === 'network-security' ? 'text-accent font-medium bg-slate-50' : 'text-slate-700'}`} data-id="element-228">
                    Network Security
                  </button>

                  <div className="border-t border-slate-100 my-1" data-id="element-229"></div>
                  <div className="px-4 py-1.5 text-xs font-bold text-slate-400 uppercase tracking-wider" data-id="element-230">
                    Infrastructure
                  </div>
                  <button onClick={() => handleNav('ethernet-cabling')} className={`block w-full text-left px-4 py-2 text-sm hover:bg-slate-50 hover:text-accent ${currentPage === 'ethernet-cabling' ? 'text-accent font-medium bg-slate-50' : 'text-slate-700'}`} data-id="element-231">
                    Ethernet Cabling
                  </button>

                  <div className="border-t border-slate-100 my-1" data-id="element-232"></div>
                  <button onClick={() => handleNav('website-design')} className={`block w-full text-left px-4 py-2 text-sm hover:bg-slate-50 hover:text-accent ${currentPage === 'website-design' ? 'text-accent font-medium bg-slate-50' : 'text-slate-700'}`} data-id="element-233">
                    🎨 Free Website Design
                  </button>
                </div>}
            </div>

            <button onClick={() => handleNav('suppliers')} className={linkClass('suppliers')} data-id="element-234">
              Suppliers
            </button>
            <button onClick={() => handleNav('contact')} className={linkClass('contact')} data-id="element-235">
              Contact Us
            </button>
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center space-x-6" data-id="element-236">
            <a href="tel:+4105255284" className="flex items-center text-slate-700 hover:text-accent font-medium transition-colors" data-id="element-237">
              <PhoneIcon className="w-4 h-4 mr-2 text-accent" data-id="element-238" />
              410-525-5284
            </a>
            <button onClick={onOpenQuote} className="bg-primary hover:bg-primary-dark text-white px-6 py-2.5 rounded-full font-medium transition-colors shadow-sm" data-id="element-239">
              Get a Quote
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden flex items-center" data-id="element-240">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-slate-600 hover:text-primary focus:outline-none" aria-label="Toggle menu" data-id="element-241">
              {mobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-242" /> : <MenuIcon className="h-6 w-6" data-id="element-243" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="lg:hidden bg-white border-t border-slate-100 absolute top-full left-0 w-full shadow-lg" data-id="element-244">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-245">
            <button onClick={() => handleNav('about')} className={`block w-full text-left px-3 py-3 text-base font-medium rounded-md ${currentPage === 'about' ? 'text-primary bg-primary/5' : 'text-slate-700 hover:bg-slate-50 hover:text-primary'}`} data-id="element-246">
              About Us
            </button>
            <button onClick={() => handleNav('domains-hosting')} className={`block w-full text-left px-3 py-3 text-base font-medium rounded-md ${currentPage === 'domains-hosting' ? 'text-primary bg-primary/5' : 'text-slate-700 hover:bg-slate-50 hover:text-primary'}`} data-id="element-247">
              Domains & Hosting
            </button>

            <div className="px-3 py-2" data-id="element-248">
              <button onClick={() => setMobileServicesOpen(!mobileServicesOpen)} className="w-full flex items-center justify-between text-base font-medium text-slate-900 mb-2 focus:outline-none" data-id="element-249">
                Services
                <ChevronDownIcon className={`w-5 h-5 transition-transform ${mobileServicesOpen ? 'rotate-180' : ''}`} data-id="element-250" />
              </button>
              {mobileServicesOpen && <div className="pl-4 space-y-2 border-l-2 border-slate-100 mt-2" data-id="element-251">
                  <button onClick={() => handleNav('business-internet')} className={`block w-full text-left py-2 text-sm hover:text-primary ${currentPage === 'business-internet' ? 'text-primary font-medium' : 'text-slate-600'}`} data-id="element-252">
                    Business Internet
                  </button>
                  <button onClick={() => handleNav('ucaas')} className={`block w-full text-left py-2 text-sm hover:text-primary ${currentPage === 'ucaas' ? 'text-primary font-medium' : 'text-slate-600'}`} data-id="element-253">
                    UCaaS Phone Systems
                  </button>
                  <button onClick={() => handleNav('ethernet-fiber')} className={`block w-full text-left py-2 text-sm hover:text-primary ${currentPage === 'ethernet-fiber' ? 'text-primary font-medium' : 'text-slate-600'}`} data-id="element-254">
                    Ethernet – Fiber
                  </button>
                  <button onClick={() => handleNav('business-phone')} className={`block w-full text-left py-2 text-sm hover:text-primary ${currentPage === 'business-phone' ? 'text-primary font-medium' : 'text-slate-600'}`} data-id="element-255">
                    Business Phone
                  </button>
                  <button onClick={() => handleNav('video-monitoring')} className={`block w-full text-left py-2 text-sm hover:text-primary ${currentPage === 'video-monitoring' ? 'text-primary font-medium' : 'text-slate-600'}`} data-id="element-256">
                    Video & Monitoring
                  </button>
                  <button onClick={() => handleNav('access-control')} className={`block w-full text-left py-2 text-sm hover:text-primary ${currentPage === 'access-control' ? 'text-primary font-medium' : 'text-slate-600'}`} data-id="element-257">
                    Access Control
                  </button>
                  <button onClick={() => handleNav('network-security')} className={`block w-full text-left py-2 text-sm hover:text-primary ${currentPage === 'network-security' ? 'text-primary font-medium' : 'text-slate-600'}`} data-id="element-258">
                    Network Security
                  </button>
                  <button onClick={() => handleNav('ethernet-cabling')} className={`block w-full text-left py-2 text-sm hover:text-primary ${currentPage === 'ethernet-cabling' ? 'text-primary font-medium' : 'text-slate-600'}`} data-id="element-259">
                    Ethernet Cabling
                  </button>
                  <button onClick={() => handleNav('website-design')} className={`block w-full text-left py-2 text-sm hover:text-primary ${currentPage === 'website-design' ? 'text-primary font-medium' : 'text-slate-600'}`} data-id="element-260">
                    Free Website Design
                  </button>
                </div>}
            </div>

            <button onClick={() => handleNav('suppliers')} className={`block w-full text-left px-3 py-3 text-base font-medium rounded-md ${currentPage === 'suppliers' ? 'text-primary bg-primary/5' : 'text-slate-700 hover:bg-slate-50 hover:text-primary'}`} data-id="element-261">
              Suppliers
            </button>
            <button onClick={() => handleNav('contact')} className={`block w-full text-left px-3 py-3 text-base font-medium rounded-md ${currentPage === 'contact' ? 'text-primary bg-primary/5' : 'text-slate-700 hover:bg-slate-50 hover:text-primary'}`} data-id="element-262">
              Contact Us
            </button>

            <div className="mt-6 pt-6 border-t border-slate-100 px-3 flex flex-col space-y-4" data-id="element-263">
              <a href="tel:+4105255284" className="flex items-center justify-center text-slate-700 font-medium py-2" data-id="element-264">
                <PhoneIcon className="w-5 h-5 mr-2 text-primary" data-id="element-265" />
                410-525-5284
              </a>
              <button onClick={() => {
            onOpenQuote?.();
            setMobileMenuOpen(false);
          }} className="w-full text-center bg-primary text-white px-6 py-3 rounded-full font-medium" data-id="element-266">
                Get a Quote
              </button>
            </div>
          </div>
        </div>}
    </header>;
}